import React, { Component } from 'react';
import { Form} from 'react-bootstrap';
import './signup.css';
import TrialSection from './trialSection';
import NameSection from './nameSection';
import PersonalDetailsSection from './personalDetailsSection';
import BusinessSection from './businessSection';
import SecuritySection from './securitySection';

class Signup extends Component {
    constructor(props){
        super(props);
        this.state={
            page:1,
            data:{},
        }
    }

    onNext=(data)=>{
        this.setState({
            page: this.state.page + 1,
            data:data
        });
    };
    onPrevious=(data)=>{
        this.setState({
            page:this.state.page-1,
            data:data
        })
    };

    render(){
        const { page,data } = this.state;
        let props={
            data:data,
            next:this.onNext,
            onPrevious:this.onPrevious,
            history:this.props.history
        };
        return(
            <Form id="SignupForm">
                {(page===1)&& <TrialSection {...props} />}
                {(page===2)&& <NameSection {...props} />}
                {(page===3)&& <PersonalDetailsSection {...props} />}
                {(page===4)&& <BusinessSection {...props} />}
                {(page===5)&& <SecuritySection {...props} />}
            </Form>

    )
    }
}
export default Signup;